export default {
  benefits: {
    earn_points: 'Zbieraj punkty przy każdym zamówieniu',
    get_deals: 'Otrzymuj ekskluzywne zniżki',
    redeem_points: 'Wymieniaj punkty na darmowe jedzenie',
  },
};
